export const POST_SPONSORED_COMMUNITY_DASHBOARD_INFO =
  "channel-reporting/dashboard/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_VIEW =
  "channel-reporting/analytics/content/view";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_CONTENT_REACH =
  "channel-reporting/analytics/content/reach";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_LOCATION_INFO =
  "channel-reporting/analytics/location/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_ZONE_INFO =
  "channel-reporting/analytics/zone/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_DEVICE_INFO =
  "channel-reporting/analytics/device/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_MOBILE_DEVICE_INFO =
  "channel-reporting/analytics/mobile-device/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_BROWSER_INFO =
  "channel-reporting/analytics/browser/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_SPECIALITY_INFO =
  "channel-reporting/analytics/speciality/info";
export const POST_SPONSORED_COMMUNITY_ANALYTICS_READS_BY_DURATION_INFO =
  "channel-reporting/analytics/reads_by_duration/info";
export const POST_SPONSORED_COMMUNITY_CONTENT_VIEWS_READS =
  "channel-reporting/content-views";
export const POST_SPONSORED_COMMUNITY_REACH =
  "channel-reporting/community-reach";
export const POST_SPONSORED_COMMUNITY_CONTENT_INFO =
  "channel-reporting/content/info";
export const POST_SPONSORED_COMMUNITY_SUBSCRIBERS_COUNT =
  "channel-reporting/subscribers-count";
export const POST_SPONSORED_COMMUNITY_COMMENTS_INFO =
  "channel-reporting/comments/info";
